<app-spinner></app-spinner>

<div class="container" style="max-width: 75% !important;" id="contact" *ngIf="!this.apierror">

  <div>
    <h1 class="text-center">Job {{ this.getOperation() }}</h1>
  </div>

  <div class="form">
    <!--TODO Form Validation-->
    <form role="form" class="php-email-form" [formGroup]="jobform" (ngSubmit)="this.onSubmit()">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="title" class="form-label">
            Title
          </label>
          <input type="text" name="title" class="form-control" id="title"
                 placeholder="Title*" formControlName="title" required
                 [class.is-invalid]="(this.getFormControls()['title'].touched || this.getFormControls()['title'].dirty) && this.getFormControls()['title'].invalid">
          <div *ngIf="this.getFormControls()['title'].touched && this.getFormControls()['title'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['title'].errors?.['required']">Der Title ist erforderlich.</div>
            <div *ngIf="this.getFormControls()['title'].errors?.['pattern']">Der Title enthält ein ungültiges Zeichen.
            </div>
            <div *ngIf="this.getFormControls()['title'].errors?.['minlength']">Der eingegebene Titel ist zu kurz</div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="customer" class="form-label">
            Kunde
          </label>
          <select class="form-control" name="customer" id="customer"
                  formControlName="customer" required title="customer"
                  [class.is-invalid]="(this.getFormControls()['customer'].touched || this.getFormControls()['customer'].dirty) && this.getFormControls()['customer'].invalid">
            <option value="" selected disabled hidden="hidden">Bitte Kunde wählen</option>
            <option *ngFor="let customer of this.customers"
              value="{{customer.uuid}}">{{ customer.display_name + " (" + customer.company_name + ")" }}
            </option>
          </select>
          <div
            *ngIf="(this.getFormControls()['customer'].touched || this.getFormControls()['customer'].dirty) && this.getFormControls()['customer'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['customer'].errors?.['required']">Der Kunde ist leider
              erforderlich
            </div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="contracttype" class="form-label">
            Vertragsart
          </label>
          <select class="form-control" name="contracttype" id="contracttype"
                  formControlName="contracttype" required
                  [class.is-invalid]="(this.getFormControls()['contracttype'].touched || this.getFormControls()['contracttype'].dirty) && this.getFormControls()['contracttype'].invalid">
            <option value="" selected disabled hidden="hidden">Bitte Vertragsart wählen</option>
            <option *ngFor="let contracttype of this.contracttype_filter"
                    value="{{contracttype.id}}">{{ contracttype.displayname }}
            </option>
          </select>
          <div
            *ngIf="(this.getFormControls()['contracttype'].touched || this.getFormControls()['contracttype'].dirty) && this.getFormControls()['contracttype'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['contracttype'].errors?.['required']">Die Vertragsart ist leider
              erforderlich
            </div>
          </div>
        </div>

        <div class="form-group col-md-12">
          <label for="description" class="form-label">
            Beschreibung
          </label>

          <editor licenseKey="gpl" id="description" class="form-control" formControlName="description"
                  [init]="{ plugins: 'lists link image table code help wordcount', language: 'de', language_url: 'assets/langs/de.js' }"
                  [class.is-invalid]="(this.getFormControls()['description'].touched ||
          this.getFormControls()['description'].dirty) && this.getFormControls()['description'].invalid"></editor>

          <div *ngIf="this.getFormControls()['description'].touched && this.getFormControls()['description'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['description'].errors?.['required']">Die Beschreibung ist erforderlich.
            </div>
            <div *ngIf="this.getFormControls()['description'].errors?.['email']">Die eingegebene Beschreibung ist leider
              ungültig.
            </div>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label for="zipcode" class="form-label">
            Postleizahl
          </label>
          <input type="number" class="form-control" name="zipcode" id="zipcode"
                 placeholder="Postleizahl" formControlName="zipcode"
                 [class.is-invalid]="(this.getFormControls()['zipcode'].touched || this.getFormControls()['zipcode'].dirty) && this.getFormControls()['zipcode'].invalid">
          <div *ngIf="this.getFormControls()['zipcode'].touched && this.getFormControls()['zipcode'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['zipcode'].errors?.['minlength']">Die eingegebene Postleizahl ist zu
              kurz
            </div>
            <div *ngIf="this.getFormControls()['zipcode'].errors?.['maxlength']">Die eingegebene Postleizahl ist zu
              lang
            </div>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label for="city" class="form-label">
            Stadt
          </label>
          <input type="text" class="form-control" name="city" id="city"
                 placeholder="Stadt*"
                 formControlName="city" required
                 [class.is-invalid]="(this.getFormControls()['city'].touched || this.getFormControls()['city'].dirty) && this.getFormControls()['city'].invalid">
          <div
            *ngIf="(this.getFormControls()['city'].touched || this.getFormControls()['city'].dirty) && this.getFormControls()['city'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['city'].errors?.['required']">Die Stadt ist leider erforderlich</div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="district" class="form-label">
            Bezirk/Distrikt
          </label>
          <input type="text" class="form-control" name="district" id="district"
                 placeholder="Distrikt/Bezirk/Stadtteil"
                 formControlName="district"
                 [class.is-invalid]="(this.getFormControls()['district'].touched || this.getFormControls()['district'].dirty) && this.getFormControls()['district'].invalid && this.getFormControls()['district'].hasValidator(Validators.required)">
          <div
            *ngIf="(this.getFormControls()['district'].touched || this.getFormControls()['city'].dirty) && this.getFormControls()['district'].invalid && this.getFormControls()['district'].hasValidator(Validators.required)"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['district'].errors?.['required']">Distrikt/Bezirk/Stadtteil ist leider
              erforderlich
            </div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="timemodel" class="form-label">
            Zeitmodell
          </label>
          <select class="form-control" name="timemodel" id="timemodel"
                  formControlName="timemodel" required
                  [class.is-invalid]="(this.getFormControls()['timemodel'].touched || this.getFormControls()['timemodel'].dirty) && this.getFormControls()['timemodel'].invalid">
            <option value="" selected disabled hidden="hidden">Bitte Zeitmodel wählen</option>
            <option *ngFor="let timemodel of this.timemodel_filter"
                    value="{{timemodel.id}}">{{ timemodel.displayname }}
            </option>
          </select>
          <div
            *ngIf="(this.getFormControls()['timemodel'].touched || this.getFormControls()['timemodel'].dirty) && this.getFormControls()['timemodel'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['timemodel'].errors?.['required']">Das Zeitmodel ist leider
              erforderlich
            </div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="remote" class="form-label">
            Remote
          </label>
          <select class="form-control" name="remote" id="remote"
                  formControlName="remote" required
                  [class.is-invalid]="(this.getFormControls()['remote'].touched || this.getFormControls()['remote'].dirty) && this.getFormControls()['remote'].invalid">
            <option value="" selected disabled hidden="hidden">Remote arbeit möglich</option>
            <option *ngFor="let remote of this.remote_filter" value="{{remote.id}}">{{ remote.displayname }}</option>
          </select>
          <div
            *ngIf="(this.getFormControls()['remote'].touched || this.getFormControls()['remote'].dirty) && this.getFormControls()['remote'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['remote'].errors?.['required']">Remote ist leider erforderlich</div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="industry" class="form-label">
            Branche
          </label>
          <select class="form-control" name="industry" id="industry"
                  formControlName="industry" required
                  [class.is-invalid]="(this.getFormControls()['industry'].touched || this.getFormControls()['industry'].dirty) && this.getFormControls()['industry'].invalid">
            <option value="" selected disabled hidden="hidden">Bitte die passende Branche wählen</option>
            <option *ngFor="let industry of this.industry_filter" value="{{industry.id}}">{{ industry.displayname }}
            </option>
          </select>
          <div
            *ngIf="(this.getFormControls()['industry'].touched || this.getFormControls()['industry'].dirty) && this.getFormControls()['industry'].invalid"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['industry'].errors?.['required']">Branche ist leider erforderlich</div>
          </div>
        </div>

        <div class="form-group col-md-12">
          <label for="perspectives" class="form-label">
            <p>Perspektiven</p>
            <small>Bitte mehrere einträge mit einem Semikolon trennen</small>
          </label>
          <textarea type="text" class="form-control" name="perspectives" rows="2" id="perspectives"
                    placeholder="Perspektiven*" formControlName="perspectives"
                    [class.is-invalid]="(this.getFormControls()['perspectives'].touched || this.getFormControls()['perspectives'].dirty) && this.getFormControls()['perspectives'].invalid"></textarea>
        </div>

        <div class="form-group col-md-12">
          <label for="timemodel" class="form-label">
            <p>Zeitmodell</p>
            <small>Bitte mehrere einträge mit einem Semikolon trennen</small>
          </label>
          <textarea type="text" class="form-control" name="tasks" rows="2" id="tasks"
                    placeholder="Aufgaben*" formControlName="tasks"
                    [class.is-invalid]="(this.getFormControls()['tasks'].touched || this.getFormControls()['tasks'].dirty) && this.getFormControls()['tasks'].invalid"></textarea>
        </div>

        <div class="form-group col-md-12">
          <label for="requirements" class="form-label">
            <p>Vorraussetzungen</p>
            <small>Bitte mehrere einträge mit einem Semikolon trennen</small>
          </label>
          <textarea type="text" class="form-control" name="requirements" rows="2" id="requirements"
                    placeholder="Anforderungen*" formControlName="requirements"
                    [class.is-invalid]="(this.getFormControls()['requirements'].touched || this.getFormControls()['requirements'].dirty) && this.getFormControls()['requirements'].invalid"></textarea>
        </div>

        <div class="form-group col-md-4">
          <label for="salary" class="form-label">
            Gehalt
          </label>
          <input type="text" class="form-control" name="salary" id="salary"
                 placeholder="Gehalt" formControlName="salary"
                 [class.is-invalid]="(this.getFormControls()['salary'].touched || this.getFormControls()['salary'].dirty) && this.getFormControls()['salary'].invalid && this.getFormControls()['salary'].hasValidator(Validators.required)">
          <div
            *ngIf="this.getFormControls()['salary'].touched && this.getFormControls()['salary'].invalid && this.getFormControls()['salary'].hasValidator(Validators.required)"
            class="alert alert-danger">
            <div *ngIf="this.getFormControls()['salary'].errors?.['minlength']">Das eingegebene Gehalt ist zu kurz</div>
            <div *ngIf="this.getFormControls()['salary'].errors?.['maxlength']">Das eingegebene Gehalt ist zu lang</div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="startdate" class="form-label">
            Beginn
          </label>
          <input type="date" class="form-control" name="startdate" id="startdate"
                 placeholder="Beginn" formControlName="startdate"
                 [class.is-invalid]="(this.getFormControls()['startdate'].touched || this.getFormControls()['startdate'].dirty) && this.getFormControls()['startdate'].invalid">
          <div *ngIf="this.getFormControls()['startdate'].touched && this.getFormControls()['startdate'].invalid"
               class="alert alert-danger">
            <div *ngIf="this.getFormControls()['startdate'].errors?.['minlength']">Das eingegebene Start Datum ist zu
              kurz
            </div>
            <div *ngIf="this.getFormControls()['startdate'].errors?.['minlength']">Das eingegebene Start Datum ist zu
              lang
            </div>
            <div *ngIf="this.getFormControls()['startdate'].errors?.['required']">Das Start Datum ist leider
              erforderlich
            </div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label for="published" class="form-label">
            Veröffentlichen
          </label>
          <select class="form-control" name="published" id="published"
                  formControlName="published" required
                  [class.is-invalid]="(this.getFormControls()['published'].touched || this.getFormControls()['published'].dirty) && this.getFormControls()['published'].invalid">
            <option value="" selected disabled hidden="hidden">Veröffentlichen ?</option>
            <option value="true">Ja</option>
            <option value="false">Nein</option>
          </select>
        </div>

        <div class="pb-3">
          <div *ngIf="this.sentstatus === 1" class="sent-message">Der Job wurde
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }}
          </div>
          <div *ngIf="this.sentstatus === 2" class="error-message">Der Job konnte leider nicht
            erfolgreich {{ this.operation === "edit" ? "Editiert" : "Erstellt" }} werden
          </div>
          <div *ngIf="this.sentstatus === 3" class="error-message">Sie haben zu viele Anfragen gestellt, bitte versuchen
            Sie es später nochmal
          </div>
        </div>
        <div class="text-center">
          <button *ngIf="this.operation === 'edit' || this.operation === 'create'" type="submit"
                  class="btn btn-success">Speichern
          </button>
          <button *ngIf="this.operation === 'delete'" (click)="this.deleteJob($event,job!.uuid)" class="btn btn-danger">
            Löschen
          </button>
        </div>
      </div>
    </form>
  </div>

</div>
